import { format } from 'date-fns';
import { router } from 'expo-router';
import { Platform, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { i18n } from '@/utils/i18n';

const ProgramsItem = ({
  canEdit,
  data,
  type,
  byLaws,
  totalGrant
}: {
  canEdit: boolean;
  data: NonProfitOrgProfileResponse['programs'];
  type: NonProfitOrgProfileResponse['type'];
  byLaws: NonProfitOrgProfileResponse['byLawsDoc'];
  totalGrant: NonProfitOrgProfileResponse['totalGrantsPrograms'];
}) => {
  const colors = useColor();

  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.programs')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('npo_details.insights.programs')} />
        </View>
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: type === 'CHURCH' ? '/edit/npoPrograms' : '/edit/npoTotalGrantsPrograms',
                params: {
                  initialByLaws: byLaws,
                  initialList: JSON.stringify(data),
                  initialTotalGrant: totalGrant
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        {data && data.length > 0 ? (
          data.map((program, index) => (
            <View style={styles.row} key={index}>
              <View>
                <Text style={[styles.valueText, { color: colors.titleText }]} fontWeight="700" numberOfLines={2}>
                  {program.name}
                </Text>
                {program.programDate && (
                  <Text style={styles.date}>{format(new Date(program.programDate), `MM/dd/yyyy hh:mm a`)}</Text>
                )}
              </View>
            </View>
          ))
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default ProgramsItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20
  },

  row: {
    flexDirection: 'row',
    marginTop: 3
  },

  valueText: {
    flex: 1,
    flexWrap: 'wrap',
    minWidth: 120,
    marginRight: 10,
    marginBottom: 5
  },

  date: {
    marginTop: 3
  },

  image: {
    marginRight: 16,
    width: 28,
    height: 28
  },

  button: {
    borderRadius: 20,
    width: Platform.OS !== 'web' ? '50%' : '100%',
    height: 34
  }
});
